// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".UploadExcel-template-btn[data-v-19f4d1ce]{width:-moz-fit-content;width:fit-content;padding:8px 20px;border-width:2px;border-radius:4px;cursor:pointer;margin-top:3px;display:block;color:#000}.UploadExcel-table-content[data-v-19f4d1ce]{padding:15px;border-radius:4px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
